import cn from 'classnames'
import Link from 'next/link'
import React from 'react'

import { HtmlContentViewer } from './HtmlContentViewer/HtmlContentViewer'

export interface PremiumPanelProps {
  icon?: string
  title?: string
  content?: string
  className?: string
  defaultText?: string
  options?: {
    name: string
    url: string
  }[]
  isHtml?: boolean
}

/**
 * Primary UI component for user interaction
 */
export const ExpertPanel: React.FC<PremiumPanelProps> = ({
  title,
  content,
  options = [],
  defaultText,
  isHtml = false,
  className,
}) => {
  return (
    <div className={cn('border-1 border-solid border rounded-[.3rem]', className)}>
      <div className="w-full bg-clouds pl-[30px] pt-[19px] pb-[14px] font-secondary font-bold text-[17px] leading-[26px] text-darkgray">
        {title}
      </div>

      {!isHtml && (
        <div className="w-full px-[24px] py-[20px]">
          {options.length === 0 && <span className="font-bold text-[.9rem] text-[#332aef]">{defaultText}</span>}
          {options.map((item) => {
            return (
              <div className="cursor-pointer">
                <Link href={item.url} className="flex flex-row items-start mb-4">
                  <span className="font-bold text-[.9rem] text-[#332aef]">•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  <span className="font-bold text-[.9rem] text-[#332aef]">{item.name}</span>
                </Link>
              </div>
            )
          })}
        </div>
      )}
      {isHtml && (
        <div className="w-full px-8 py-4">
          <HtmlContentViewer html={content || ''} className="header-des-html" />
        </div>
      )}
    </div>
  )
}

export default ExpertPanel
